module.exports = __webpack_public_path__ + "static/media/Bruckner.02661038.jpeg";